import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import { Control, Controller } from 'react-hook-form';
import { CreateAccountAndUser } from '@quick/client';
import { GUTTER } from '../components/Gutter';
import { isEmail } from '../../../utils/EmailUtils';

interface PrimaryContactFormProps {
  control: Control<CreateAccountAndUser>;
}

const PrimaryContactForm: React.FC<PrimaryContactFormProps> = ({ control }) => {
  return (
    <Form layout="vertical" colon={false} requiredMark={false} preserve={false}>
      <h6 className="my-6">Primary contact</h6>
      <Row justify="space-between" gutter={GUTTER}>
        <Col span={12}>
          <Controller
            control={control}
            name="accountUserFirstName"
            rules={{
              required: 'First name is required',
            }}
            render={({ field, fieldState }) => (
              <Form.Item
                preserve
                required
                label="First name"
                validateStatus={fieldState.error && 'error'}
                help={fieldState.error?.message}
              >
                <Input autoFocus className="flex-grow-1" {...field} />
              </Form.Item>
            )}
          />
        </Col>
        <Col span={12}>
          <Controller
            control={control}
            name="accountUserLastName"
            rules={{
              required: 'Last name is required',
            }}
            render={({ field, fieldState }) => (
              <Form.Item
                preserve
                required
                label="Last name"
                validateStatus={fieldState.error && 'error'}
                help={fieldState.error?.message}
              >
                <Input className="flex-grow-1" {...field} />
              </Form.Item>
            )}
          />
        </Col>
      </Row>
      <Controller
        control={control}
        name="accountUserEmail"
        rules={{
          validate: (value: string | undefined) => {
            if (!value) {
              return 'Please input your email address';
            }
            if (!isEmail(value)) {
              return 'Please enter a valid email!';
            }
            return true;
          },
        }}
        render={({ field, fieldState }) => (
          <Form.Item
            required
            label="Email"
            validateStatus={fieldState.error && 'error'}
            help={fieldState.error?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <Controller
        control={control}
        name="accountUserPhoneNumber"
        rules={{
          minLength: {
            value: 9,
            message: 'Please input a valid phone number',
          },
          required: false,
        }}
        render={({ field, fieldState }) => (
          <Form.Item
            required
            label="Phone number"
            validateStatus={fieldState.error && 'error'}
            help={fieldState.error?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
    </Form>
  );
};

export default PrimaryContactForm;
